/** Grey pseudo-status for HubSpot import rows. */
export default function HubspotBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-chip border border-dashed border-paper-border2 bg-paper-muted px-2.5 py-1 text-[11px] font-semibold text-ink-faint">
      HubSpot
    </span>
  );
}
